module.exports = __webpack_public_path__ + "static/media/Fair.a5555a4d.jpg";